import {
  $addUpdateTag,
  COMMAND_PRIORITY_CRITICAL,
  type LexicalEditor,
  SELECTION_CHANGE_COMMAND,
  SKIP_DOM_SELECTION_TAG,
} from "lexical";

export type ComposerSelectionRange = {
  start: number;
  end: number;
};

export function didComposerSelectionChangeVisibly(
  previous: ComposerSelectionRange,
  next: ComposerSelectionRange | null,
): boolean {
  return (
    next !== null &&
    next.start !== next.end &&
    (next.start !== previous.start || next.end !== previous.end)
  );
}

/**
 * Lexical answers a selection change by writing the selection back to the
 * page and focusing the editor. A click on the chart beside an embedded chat
 * moves focus without moving the selection (the chart holds none), so a
 * selection change that lands after it would pull focus back into the
 * composer. While `owns` says the focused element is outside the chat's
 * focus container, the editor only notes its selection.
 */
export const keepComposerFocusInside = (editor: LexicalEditor, owns: (target: EventTarget | null) => boolean) =>
  editor.registerCommand(
    SELECTION_CHANGE_COMMAND,
    () => {
      if (!owns(document.activeElement)) $addUpdateTag(SKIP_DOM_SELECTION_TAG);
      return false;
    },
    COMMAND_PRIORITY_CRITICAL,
  );
